import { h, Fragment } from "preact";

import { Box, Button, Grid, Paper, Stack, Typography } from "@mui/material";

import PersonIcon from "@mui/icons-material/Person";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import DateRangeIcon from "@mui/icons-material/DateRange";
import EditIcon from '@mui/icons-material/Edit';
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import { CheckTexVal, } from "../Common/helpers";
import CardTemplate from "../Common/CardTemplate";

export default function PersonnalCard({ user, role }) {

	return (
		<CardTemplate
			title="Vos informations personnelles"
			buttons={<Box display={"flex"}
				alignItems="center"
				justifyContent={"space-between"}
			>
				<Box >
					<ButtonWithTooltipAndBadge
						tooltip="Voir mon profil"
						icon={<EditIcon />}
						onclick_cb={() => {
							window.location.href = "/user?from=" + window.location.href;
						}}
						badge={!user.user_all_ok}
					/>
				</Box>
				{role === "AM" &&
					<Box style={{ paddingLeft: "8px" }}>
						<ButtonWithTooltipAndBadge
							style="margin-left: 10px;"
							tooltip="Gérer mes rendez-vous"
							icon={<DateRangeIcon />}
							onclick_cb={() => {
								window.location.href = "/e668ce390be04a6b88aa54d048a49b55?tab=rdv";
							}}
							badge={!user.ambassador_schedule_set}
						/>
					</Box>
				}
			</ Box>}

			content={user && (
				<Grid container >
					<Grid item xs={12}>
						<Stack flexDirection={"row"} justifyContent="flex-start" alignItems="center">
							<PersonIcon color="primary" style="margin-right: 10px;" />

							<Typography variant="body1">
								{user.fname} {user.lname}
							</Typography>
						</Stack>
					</Grid>
					<Grid item xs={12}>
						<Box display="flex" justifyContent="flex-start" alignItems="center">
							<Box>
								<HomeIcon color="primary" style="margin-right:10px;" />
							</Box>
							<Box>
								{(CheckTexVal(user.addr_line1) && CheckTexVal(user.addr_zip_code) &&
									CheckTexVal(user.addr_city))
									? (
										<Fragment>
											<Typography variant="body1">{user.addr_line1}</Typography>
											<Typography variant="body1">
												{user.addr_zip_code} {user.addr_city}
											</Typography>
										</Fragment>
									) : (
										<Typography variant="body1">
											<em>Adresse incomplète</em>
										</Typography>
									)}
							</Box>
						</Box>
					</Grid>
					<Grid item xs={12} lg={6}>
						<Stack flexDirection={"row"} justifyContent="flex-start" alignItems="center">

							<MailOutlineIcon color="primary" style="margin-right: 10px;" />

							<Typography variant="body1">{user.mail}</Typography>

						</Stack>
					</Grid>
					<Grid item xs={12} lg={6}>
						<Stack flexDirection={"row"} justifyContent="flex-start" alignItems="center">

							<PhoneIcon color="primary" style="margin-right: 10px; " />

							<Typography variant="body1">
								{typeof user.phone === "string" && user.phone.length > 0 ? (
									<Typography variant="body1">{user.phone}</Typography>
								) : (
									<em>Téléphone non enregistré</em>
								)}
							</Typography>
						</Stack>
					</Grid>
				</Grid>

			)}


		/>)

}